import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import {
    NestedFormGroupType,
    FormGroupType,
} from '../../../../../../core/models/form-group-type';
import { RegExPattern } from '../../../../../../core/models/regexp-pattern/regex-pattern';
import { AssocCallSignBase } from '../../models/assoc-call-sign-base';
import { AssocControlPointBase } from '../../models/assoc-control-point-base';
import { ScheduleHAdditionalInformationResponse } from '../../models/schedule-h-additional-information-response';
import { ScheduleHAdditionalInformationRegExPattern } from '../../constants/schedule-h-additional-information-regex-pattern';

@Injectable({
    providedIn: 'root',
})
export class ScheduleHAdditionalInformationFormService {
    constructor() {}

    getFormDefinition() {
        return new FormGroup<
            NestedFormGroupType<ScheduleHAdditionalInformationResponse>
        >({
            id: new FormControl<number | undefined>(undefined),
            eligibilityRuleNumber: new FormControl<string | undefined>(
                undefined,
                [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(
                        ScheduleHAdditionalInformationRegExPattern.RuleSectionCharacters,
                    ),
                ],
            ),
            eligibleActivityDescription: new FormControl<string | undefined>(
                undefined,
                [
                    Validators.required,
                    Validators.maxLength(255),
                    Validators.pattern(
                        RegExPattern.PrintableAsciiExceptAngleBracketsAndPipes,
                    ),
                ],
            ),
            extendedImplementation: new FormControl<boolean | undefined>(
                undefined,
                Validators.required,
            ),
            assocCallSigns: new FormArray<
                FormGroup<FormGroupType<AssocCallSignBase>>
            >([]),
            assocControlPoints: new FormArray<
                FormGroup<FormGroupType<AssocControlPointBase>>
            >([], Validators.required),
        });
    }
}
